<template>
    <span>
        <span v-observe-visibility="visibilityChanged" />
        <v-tooltip v-if="tooltipRequired" z-index="300" bottom :max-width="maxWidth">
            <template v-slot:activator="{ props: activatorProps }">
                <span v-bind="activatorProps">
                    {{ truncatedText }}
                </span>
            </template>

            <span>{{ text }}</span>
        </v-tooltip>
        <span v-else> {{ truncatedText }} </span>
    </span>
</template>

<script setup>
import { ref, computed } from 'vue';
import { truncate } from 'lodash';

const props = defineProps({
    text: {
        type: String,
        default: null,
    },
    maxWidth: {
        type: Number,
        default: 300,
    },
    length: {
        type: Number,
        default: 60,
    },
});

const isVisible = ref(false);

const truncatedText = computed(() =>
    truncate(props.text, {
        length: props.length,
        omission: '...',
    })
);
const tooltipRequired = computed(() => isVisible.value && truncatedText.value !== props.text);

const visibilityChanged = visible => {
    isVisible.value = visible;
};
</script>
